import { render, staticRenderFns } from "./billsDetail.vue?vue&type=template&id=61ab608f&scoped=true&"
import script from "./billsDetail.vue?vue&type=script&lang=js&"
export * from "./billsDetail.vue?vue&type=script&lang=js&"
import style0 from "./billsDetail.vue?vue&type=style&index=0&id=61ab608f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab608f",
  null
  
)

export default component.exports